import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TermDepositListState } from '../types';
import { fetchExpiringTermDeposit } from './thunks';
import { PagedRequest } from "src/store";

export const initialState: TermDepositListState = {
  parameters: {
    clientNameSearch: '',
    pagination: {
      pageNumber: 1,
      pageSize: 25,
      queryFields: [],
    },
  },
  termDepositList: null,
  fetchTermDepositError: false
};

export const expiringTermDepositsSlice = createSlice({
  name: '@@termDeposit/associations',
  initialState,
  reducers: {
     setSearchStringParameter: (state, action: PayloadAction<string | null>) => {
        state.parameters.clientNameSearch = action.payload;
    },
    setPaginationParameter: (state, action: PayloadAction<PagedRequest>) => {
        state.parameters.pagination = action.payload;
    }
  },
  extraReducers: (builder) => {

    builder.addCase(fetchExpiringTermDeposit.fulfilled, (state, action) => {
      state.termDepositList = action.payload; 
      state.parameters.pagination = {
        pageNumber: action.payload.pageNumber,
        pageSize: action.payload.pageSize,
        queryFields: state.parameters.pagination.queryFields
      };
    });

    builder.addCase(fetchExpiringTermDeposit.rejected, (state) => {
      state.fetchTermDepositError = true;
    });

     builder.addCase(fetchExpiringTermDeposit.pending, (state) => {
      state.fetchTermDepositError = false;
    });
  },
});
